import { render, staticRenderFns } from "./register-mcheckBox.vue?vue&type=template&id=e258ff7c&scoped=true&"
import script from "./register-mcheckBox.vue?vue&type=script&lang=js&"
export * from "./register-mcheckBox.vue?vue&type=script&lang=js&"
import style0 from "./register-mcheckBox.vue?vue&type=style&index=0&id=e258ff7c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e258ff7c",
  null
  
)

export default component.exports